import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Modal,
  AvatarGroup,
  Avatar,
  Button,
} from "@mui/material";

import LockIconImg from "../../common/assests/lockicons.png";
import DeleteIconImg from "../../common/assests/deleticon.png";
import TestingImg from "../../common/assests/gridimg3.png";
import ClockIcon from "../../common/assests/clock.svg";
import CrossIcon from "../../common/assests/croosicon.png";
import Adminimg from "../../common/assests/adminimg.png";
import location from "../../common/assests/location.svg";
import DelIcon from "../../common/assests/delIcon.svg";
import Locks from "../../common/assests/lockicon.svg";
import Pb from "../../common/assests/pb.svg";
import WatchLaterRoundedIcon from "@mui/icons-material/WatchLaterRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import Paginations from "../../common/pagination/Paginations";
import { useSelector } from "react-redux";
import {
  allVenderEventsApi,
  blockVenderEventApi,
  deleteVenderEventApi,
  resumeVenderEventApi,
} from "../../api";
import { useParams } from "react-router-dom";
import Loader from "../../common/loader/Loader";
import BlockIcon from "../../common/assests/blockIcon.png";
import { toast } from "react-toastify";
import configuration from "../../config/Config";

const CreatedEvent = () => {
  const token = useSelector((state) => state?.user?.user?.token);

  const { id } = useParams();
  const [eventData, setEventData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [change, setChange] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();

  const handleAllEventsData = async () => {
    try {
      setLoading(true);
      const response = await allVenderEventsApi({ token, currentPage, id });
      setEventData(response?.events || []);
      // console.log("events", response);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  const handleBlock = async (id) => {
    const confirmationMessage =
      "Are you sure, you want to Unpublish this resource?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await blockVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response.message);
      setOpen(false);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  const handleResume = async (id) => {
    const confirmationMessage =
      "Are you sure, you want to publish this resource?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await resumeVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response.message);
      setOpen(false);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmationMessage =
      "Are you sure, you want to Delete this resource?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await deleteVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response.message);
      setOpen(false);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleAllEventsData();
  }, [currentPage, change]);

  const handleOpen = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };

  const isPublished = selectedEvent?.status === "active";
  const handleClose = () => setOpen(false);

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>
      {loading ? (
        <Loader variant="cardList" />
      ) : (
        <Box
          sx={{
            borderRadius: "24px",
            background: "#FFF",
            boxShadow: "3px 2px 20px 0px rgba(0, 0, 0, 0.04)",
            padding: "16px",
            width: "100%",
            maxWidth: "1460px",
            margin: "auto",
            boxSizing: "border-box",
            overflow: "hidden",
            marginTop: "40px",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "500",
              color: "#362B24",
              fontFamily: "Heebo",
            }}
          >
            All Created Events
          </Typography>

          <Box>
            {eventData.length > 0 ? (
              eventData.map((item) => (
                <Box
                  key={item._id}
                  onClick={() => handleOpen(item)}
                  sx={{
                    borderRadius: "22px",
                    background: "#FFF",
                    boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                    maxWidth: "1380px",
                    height: "auto",
                    minHeight: "116px",
                    flexShrink: 0,
                    marginBottom: "16px",
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px",
                    boxSizing: "border-box",
                    flexDirection: { xs: "column", sm: "row" },
                    cursor: "pointer",
                  }}
                >
                  {/* Left Side: Image and Event Details */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: { xs: "20px", sm: "0px" },
                      width: "100%",
                      opacity: item.status === "active" ? 0.4 : 1,
                    }}
                  >
                    <img
                      src={
                        item?.picture
                          ? `${configuration.cdnFront}/${item.picture}`
                          : TestingImg
                      }
                      alt="Event"
                      style={{
                        borderRadius: "13px",
                        marginRight: "16px",
                        width: "91px",
                        height: "96px",
                        objectFit: "cover",
                      }}
                    />
                    <Box>
                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <Typography
                          sx={{
                            fontSize: "17px",
                            fontWeight: "600",
                            color: "#362B24",
                            fontFamily: "Heebo",
                          }}
                        >
                          {item?.title || "-"}
                        </Typography>
                        <img
                          src={ClockIcon}
                          alt="Clock"
                          style={{
                            marginLeft: "12px",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#065F46",
                            fontFamily: "Heebo",
                            marginLeft: "5px",
                          }}
                        >
                          {item?.eventDate
                            ? new Date(item?.eventDate).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                        </Typography>
                      </Box>

                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#7D6F6F",
                          fontFamily: "Heebo",
                          maxWidth: "300px",
                          fontWeight: "400",
                        }}
                      >
                        {item?.cTag || "-"}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "12px",
                          color: "#7D6F6F",
                          fontFamily: "Heebo",
                          maxWidth: "900px",
                          width: "100%",
                          opacity: "0.6",
                        }}
                      >
                        {item?.description || "N/A"}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Right Side: Action Icons */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <IconButton onClick={() => handleOpen(item)}>
                      <img
                        src={item.status === "active" ? BlockIcon : LockIconImg}
                        alt="Block/Unlock"
                      />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(item?._id)}>
                      <img src={DeleteIconImg} alt="Delete" />
                    </IconButton>
                  </Box>
                </Box>
              ))
            ) : (
              <Typography align="center">No Data Found</Typography>
            )}
          </Box>

          <Paginations
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            disabled={loading}
          />
        </Box>
      )}

      {/* Modal */}
      {selectedEvent && (
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80vw", sm: "80vw" },
            maxWidth: "630px",
            bgcolor: "#FFF",
            borderRadius: "32px",
            boxShadow: 24,
            maxHeight: "80vh",
            p: 4,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
              Event Details
            </Typography>
            <IconButton onClick={handleClose}>
              <img
                src={CrossIcon}
                alt="img"
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
            </IconButton>
          </Box>

            <>
              <img
                      src={
                        selectedEvent?.picture
                          ? `${configuration.cdnFront}/${selectedEvent?.picture}`
                          : TestingImg
                      }
                alt="Event"
                style={{
                  width: "100%",
                  maxHeight: "263px",
                  borderRadius: "20px",
                  marginTop: "15px",
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  mt: 3,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#362B24",
                    fontFamily: "Heebo",
                  }}
                >
                  {selectedEvent?.title||"-"}
                </Typography>
                <Box
                  sx={{
                    borderRadius: "28px",
                    background: "#362B24",
                    boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                    width: "110px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    padding: "0 8px",
                    flexShrink: 0,
                    gap: 1,
                  }}
                >
                  <WatchLaterRoundedIcon
                    sx={{ color: "#FFF", width: "18px", height: "18px" }}
                  />
                  <Typography sx={{ color: "#FFF", fontSize: "10px" }}>
                  {selectedEvent?.eventDate
                            ? new Date(selectedEvent?.eventDate).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "-"}
                  </Typography>
                </Box>
              </Box>

              <Typography
                sx={{
                  fontWeight: "400",
                  color: "#362B24",
                  fontSize: "13px",
                  fontFamily: "Heebo",
                  marginTop: "10px",
                }}
              >
                Event Category
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: 3,
                  marginTop: "15px",
                  flexWrap: "wrap",
                }}
              >
                <Typography>
                  <div className="d-flex gap-2">
                    <img src={location} />
                    <div
                      style={{
                        color: "#065F46",
                        fontSize: "13px",
                        fontWeight: "400",
                        fontFamily: "Heebo",
                      }}
                    >
                     {selectedEvent?.address||"-"}
                    </div>
                  </div>
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: "17px",
                  fontWeight: "600",
                  color: "#362B24",
                  fontFamily: "Heebo",
                  mt: 3,
                }}
              >
                Description
              </Typography>
              <Typography sx={{ mb: 2, opacity: 0.5, fontFamily: "Heebo" }}>
               {selectedEvent?.description||"-"}
              </Typography>

              {/* btns */}
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  marginTop: "25px",
                  // opacity: isPublished ? 0.4 : 1
                }}
              >
                <button
                  onClick={
                    isPublished
                      ? () => handleBlock(selectedEvent?._id)
                      : () => handleResume(selectedEvent?._id)
                  }
                  style={{
                    borderRadius: "15px",
                   
                    backgroundColor: isPublished ? "#d7d5d3" : "#362B24", 
                    color: isPublished ? "#000" : "#FFF",
                    
                    width: "190px",
                    height: "50px",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Heebo",
                    textTransform: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <img
                    src={isPublished ? Locks : Pb}
                    className="me-2"
                    alt={isPublished ? "Publish" : "Unpublish"}
                  />
                  {isPublished ? "Unpublish" : "Publish"}
                </button>
                <button
                  onClick={() => handleDelete(selectedEvent?._id)}
                  style={{
                    borderRadius: "15px",
                    backgroundColor: "#EA001B",
                    width: "190px",
                    height: "50px",
                    flexShrink: 0,
                    color: "#FFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "Heebo",
                    border: "none",
                    textTransform: "none",
                    cursor: "pointer",
                  }}
                >
                  <img src={DelIcon} className="me-2" />
                  Delete
                </button>
              </div>
            </>
          
        </Box>
      </Modal>
      )}
    </div>
  );
};

export default CreatedEvent;
